/**
 * OAF homepage sections — hero slider + FAQ accordion + grid carousels
 */
(function () {
  function initHero(root) {
    var track = root.querySelector('.oaf-hero__track');
    if (!track) return;
    var slides = track.querySelectorAll('.oaf-hero__slide');
    if (slides.length <= 1) return;

    var index = 0;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-speed') || '5', 10) * 1000;
    var timer;

    function go(i) {
      index = (i + slides.length) % slides.length;
      var n = slides.length;
      track.style.transform = 'translateX(calc(-' + index + ' * 100% / ' + n + '))';
      var dots = root.querySelectorAll('.oaf-hero__dot');
      dots.forEach(function (d, di) {
        d.setAttribute('aria-current', di === index ? 'true' : 'false');
      });
    }

    function next() {
      go(index + 1);
    }

    function prev() {
      go(index - 1);
    }

    var nextBtn = root.querySelector('[data-oaf-hero-next]');
    var prevBtn = root.querySelector('[data-oaf-hero-prev]');
    if (nextBtn) nextBtn.addEventListener('click', function () {
      next();
      resetTimer();
    });
    if (prevBtn) prevBtn.addEventListener('click', function () {
      prev();
      resetTimer();
    });

    root.querySelectorAll('.oaf-hero__dot').forEach(function (dot, di) {
      dot.addEventListener('click', function () {
        go(di);
        resetTimer();
      });
    });

    function resetTimer() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(next, speed);
    }

    if (autoplay) {
      timer = setInterval(next, speed);
      root.addEventListener('mouseenter', function () {
        clearInterval(timer);
      });
      root.addEventListener('mouseleave', function () {
        resetTimer();
      });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) clearInterval(timer);
      else resetTimer();
    });
  }

  function initFaq(root) {
    var items = root.querySelectorAll('.oaf-faq__item');
    items.forEach(function (item) {
      var btn = item.querySelector('.oaf-faq__trigger');
      var panel = item.querySelector('.oaf-faq__panel');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        items.forEach(function (other) {
          other.classList.remove('is-open');
          var p = other.querySelector('.oaf-faq__panel');
          var b = other.querySelector('.oaf-faq__trigger');
          if (p) p.hidden = true;
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          panel.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initGridSliders() {
    document.querySelectorAll('[data-oaf-grid-slider]').forEach(function (el) {
      if (window.matchMedia('(min-width: 990px)').matches && el.getAttribute('data-slider-desktop') === 'false') {
        return;
      }
    });
  }

  function initCategorySlider(root) {
    var trackOuter = root.querySelector('[data-oaf-slider-track]');
    var trackInner = trackOuter ? trackOuter.querySelector('.oaf-slider__track') : null;
    var slides = root.querySelectorAll('.oaf-slider__slide');
    if (!trackInner || slides.length === 0) return;

    var prevBtn = root.querySelector('[data-oaf-slider-prev]');
    var nextBtn = root.querySelector('[data-oaf-slider-next]');
    var dotsContainer = root.querySelector('[data-oaf-slider-dots]');

    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-speed') || '5', 10) * 1000;
    var slidesDesktop = parseInt(root.getAttribute('data-slides-desktop') || '4', 10);
    var slidesMobile = parseInt(root.getAttribute('data-slides-mobile') || '1', 10);
    var arrowsMobile = root.getAttribute('data-arrows-mobile') === 'true';

    var index = 0;
    var timer = null;
    var mq = window.matchMedia('(min-width: 750px)');
    var dots = [];

    function getSlidesPerView() {
      return mq.matches ? slidesDesktop : slidesMobile;
    }

    function getMaxIndex() {
      var perView = getSlidesPerView();
      return Math.max(0, slides.length - perView);
    }

    function setSlideSizes() {
      var perView = getSlidesPerView();
      var slidePercent = 100 / perView;

      slides.forEach(function (slide) {
        slide.style.flex = '0 0 ' + slidePercent + '%';
        slide.style.width = slidePercent + '%';
        slide.style.maxWidth = slidePercent + '%';
      });
    }

    // Create dots dynamically based on slide positions
    function createDots() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      dots = [];

      var maxIndex = getMaxIndex();
      var totalDots = maxIndex + 1;

      for (var i = 0; i < totalDots; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'oaf-slider-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('data-slide-index', i);
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        dot.addEventListener('click', (function (idx) {
          return function () {
            go(idx);
            resetTimer();
          };
        })(i));
        dotsContainer.appendChild(dot);
        dots.push(dot);
      }
    }

    function updateDots() {
      dots.forEach(function (d, di) {
        var isActive = di === index;
        d.classList.toggle('is-active', isActive);
        d.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function go(i) {
      var maxIndex = getMaxIndex();
      var perView = getSlidesPerView();
      index = Math.max(0, Math.min(i, maxIndex));

      // Calculate translate based on slide index
      var slidePercent = 100 / perView;
      var translatePercent = index * slidePercent;

      trackInner.style.transform = 'translateX(-' + translatePercent + '%)';
      trackInner.style.transition = 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)';

      updateDots();
      updateControlsVisibility();
    }

    function next() {
      var maxIndex = getMaxIndex();
      if (index < maxIndex) {
        go(index + 1);
      } else if (autoplay) {
        go(0);
      }
    }

    function prev() {
      go(index - 1);
    }

    function resetTimer() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(next, speed);
    }

    function stopTimer() {
      clearInterval(timer);
    }

    function shouldShowSlider() {
      var perView = getSlidesPerView();
      return slides.length > perView;
    }

    function shouldShowArrows() {
      var isMobile = !mq.matches;
      if (isMobile && !arrowsMobile) return false;
      return shouldShowSlider();
    }

    function updateControlsVisibility() {
      var maxIndex = getMaxIndex();
      var showArrows = shouldShowArrows();
      var navContainer = root.querySelector('.oaf-slider-nav');

      // Show/hide nav container
      if (navContainer) {
        navContainer.style.display = showArrows ? 'flex' : 'none';
      }

      // Show/hide arrows
      if (prevBtn) {
        prevBtn.style.display = showArrows ? 'flex' : 'none';
        prevBtn.style.visibility = index === 0 ? 'hidden' : 'visible';
        prevBtn.style.pointerEvents = index === 0 ? 'none' : 'auto';
        prevBtn.disabled = index === 0;
      }
      if (nextBtn) {
        nextBtn.style.display = showArrows ? 'flex' : 'none';
        nextBtn.style.visibility = index >= maxIndex ? 'hidden' : 'visible';
        nextBtn.style.pointerEvents = index >= maxIndex ? 'none' : 'auto';
        nextBtn.disabled = index >= maxIndex;
      }

      // Show/hide dots
      if (dotsContainer) {
        dotsContainer.style.display = shouldShowSlider() ? 'flex' : 'none';
      }
    }

    // Event listeners
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        resetTimer();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        resetTimer();
      });
    }

    // Touch/swipe support
    var startX = 0;
    var isDragging = false;

    trackOuter.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      isDragging = true;
      stopTimer();
    }, { passive: true });

    trackOuter.addEventListener('touchend', function (e) {
      if (!isDragging) return;
      isDragging = false;

      var endX = e.changedTouches[0].clientX;
      var diff = startX - endX;

      if (Math.abs(diff) > 50) {
        if (diff > 0) next(); else prev();
      }
      resetTimer();
    }, { passive: true });

    function onBreakpointChange() {
      createDots();
      setSlideSizes();
      // Adjust index if out of bounds
      var maxIndex = getMaxIndex();
      if (index > maxIndex) index = maxIndex;
      go(index);
      updateControlsVisibility();
    }

    function init() {
      createDots();
      setSlideSizes();
      updateControlsVisibility();

      if (!shouldShowSlider()) return;

      go(0);

      if (autoplay) {
        timer = setInterval(next, speed);
        root.addEventListener('mouseenter', stopTimer);
        root.addEventListener('mouseleave', resetTimer);
      }

      // Media query change
      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', onBreakpointChange);
      } else {
        mq.addListener(onBreakpointChange);
      }

      // ResizeObserver
      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(function () {
          setSlideSizes();
          go(index);
        });
        ro.observe(trackOuter);
      }
    }

    // Delay init to ensure DOM is ready
    if (document.readyState === 'complete') {
      setTimeout(init, 100);
    } else {
      window.addEventListener('load', function () {
        setTimeout(init, 100);
      });
    }

    // Fallback init
    setTimeout(init, 500);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopTimer();
      else if (autoplay) resetTimer();
    });
  }

  function initCarouselGrid(root) {
    var mode = root.getAttribute('data-mode') || 'grid';
    if (mode === 'grid') return;

    var track = root.querySelector('.oaf-cg__track');
    var slides = root.querySelectorAll('.oaf-cg__slide');
    if (!track || slides.length === 0) return;

    var mq = window.matchMedia('(min-width: 990px)');
    var index = 0;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-speed') || '5', 10) * 1000;
    var timer;

    function hybridDesktop() {
      return mode === 'hybrid' && mq.matches;
    }

    function go(i) {
      if (hybridDesktop()) return;
      index = (i + slides.length) % slides.length;
      var n = slides.length;
      track.style.transform = 'translateX(calc(-' + index + ' * 100% / ' + n + '))';
      root.querySelectorAll('.oaf-cg__dot').forEach(function (d, di) {
        d.setAttribute('aria-current', di === index ? 'true' : 'false');
      });
    }

    function next() {
      go(index + 1);
    }

    function prev() {
      go(index - 1);
    }

    var nextBtn = root.querySelector('[data-oaf-cg-next]');
    var prevBtn = root.querySelector('[data-oaf-cg-prev]');
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        resetTimer();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        resetTimer();
      });
    }

    root.querySelectorAll('.oaf-cg__dot').forEach(function (dot, di) {
      dot.addEventListener('click', function () {
        go(di);
        resetTimer();
      });
    });

    function resetTimer() {
      if (!autoplay || hybridDesktop()) return;
      clearInterval(timer);
      timer = setInterval(next, speed);
    }

    function onBreakpoint() {
      if (hybridDesktop()) {
        track.style.transform = '';
      } else {
        go(index);
      }
      if (autoplay && !hybridDesktop()) {
        clearInterval(timer);
        timer = setInterval(next, speed);
      } else {
        clearInterval(timer);
      }
    }

    if (slides.length <= 1) {
      var navEls = root.querySelectorAll('.oaf-cg__nav');
      navEls.forEach(function (n) {
        n.style.display = 'none';
      });
      var dotsEl = root.querySelector('.oaf-cg__dots');
      if (dotsEl) dotsEl.style.display = 'none';
      return;
    }

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onBreakpoint);
    } else {
      mq.addListener(onBreakpoint);
    }
    window.addEventListener('resize', onBreakpoint);
    onBreakpoint();
  }

  function initAll() {
    document.querySelectorAll('[data-oaf-hero]').forEach(initHero);
    document.querySelectorAll('[data-oaf-faq]').forEach(initFaq);
    document.querySelectorAll('[data-oaf-cg]').forEach(initCarouselGrid);
    document.querySelectorAll('[data-oaf-cat-slider]').forEach(initCategorySlider);
    initGridSliders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
